
import Absp from "../images/digital-art.jpg"
import Wda from "../images/digital-art-2.png"

export const images = [
  Absp,Wda
]
  